var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconWrite48Line = function SvgIconWrite48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3 33.4a1.9 1.9 0 0 1-1.9 1.9H14.6a1.9 1.9 0 0 1-1.9-1.9V16.6c0-1.05.85-1.9 1.9-1.9H22v-3.4h-7.4a5.31 5.31 0 0 0-5.3 5.3v16.8c0 2.92 2.38 5.3 5.3 5.3h16.8c2.92 0 5.3-2.38 5.3-5.3V26h-3.4v7.4Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m37.85 13.48-3.33-3.33a2.903 2.903 0 0 0-4.1 0L18.7 21.87c-.24.24-.4.54-.47.87l-.89 4.5a2.892 2.892 0 0 0 2.84 3.46c.19 0 .38-.02.56-.05l4.5-.89c.33-.07.64-.23.87-.47l11.72-11.72a2.903 2.903 0 0 0 0-4.1l.02.01ZM24.09 26.53l-3.26.64.64-3.26 11-11 2.62 2.62-11 11Z",
    fill: "current"
  })));
};
export default SvgIconWrite48Line;